export default __webpack_public_path__ + "static/media/trash.80d71fc4.svg";